import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/reports/index.php",
    parse: function (data) {
        this.lang = data.lang;
        delete data.lang;
        return data;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/models/reportModel.js
// module id = 175
// module chunks = 0